import { Messages } from '../langs';

const en: Messages = {
    common: {
        loading: 'Loading',
        unauthorized: 'Unauthorized',
        not_found: 'Ressource not found',
        unknown_error: 'Unknown error',
        hide_details: 'Hide details',
        ok: 'OK',
        cancel: 'Cancel',
        edit: 'Edit',
        config: 'Configured',
        delete: 'Delete',
        freedevice: 'Free the device',
        new: 'New',
        applications: 'Applications',
        reset: 'Reset',
        noDate: 'No date selected',
        actions: 'Actions',
        free_deviceapplication: 'Free the application',
        upload_config: 'Upload configuration',
        file: 'Configuration by file',
        placeholder: 'Choose a file or drop it here...',
        drop_placeholder: 'Drop file here...',
        browse_text: 'Browse',
        os: 'OS',
        device_id: 'Device id',
        device_name: 'Device name',
        registered_date: 'Registration date',
        last_connection_date: 'Last connection date',
        error_freedevice: 'Unable to free application device',
        clusters: 'Clusters',
        users: 'Users',
        user: 'User',
        status: 'Status',
        id: 'Id',
        created_at: 'Created at',
        updated_at: 'Updated at',
        refresh: 'Refresh',
        stop: 'Stop',
        size: 'Size',
        config_files: 'Configuration files',
        email: 'E-mail',
        events: 'Events'
    },

    view: {
        Login: {
            login: 'Login',
            password: 'Password',
            connection: 'Log in',
            continue: 'Continue',
            step_credentials: 'Please sign in',
            step_contract: 'Please choose the contract',
            step_application: 'Please choose the application profile',
            step_credentials_help: '',
            step_contract_help: '',
            step_application_help: '',
            lost_password: 'Forgot password ?',
            lost_login: 'Forgot login ?',
            access_denied: 'No view enabled',
            choose_contract: 'Contract',
            choose_contract_placeholder: 'Choose a contract',
            choose_application: 'Application',
            choose_application_placeholder: 'Choose an application',
            choose_application_help: '',
            error_choose_contract: 'Please choose a contract to continue',
            error_choose_application: 'Please choose an application to continue',
            error_wrong: 'Incorrect password or login',
            error_not_linked_to_application: 'Your account is not linked to any application for the backoffice',
            error_session_expired: 'Session expired, please log in again',
        },
        LostPassword: {
            title: 'Lost password',
            login: 'Login',
            send: 'Send',
            back_to_login: 'Back to login',
            error_wrong: 'Incorrect login',
            success: 'An email has been sent to reinitialize your password',
        },
        LostLogin: {
            title: 'Lost login',
            email: 'Email',
            send: 'Send',
            back_to_login: 'Back to login',
            error_wrong: 'Incorrect email',
            success: 'An email has been sent with your login',
        },
        InitPassword: {
            title: 'Change password',
            password: 'New password',
            confirm_password: 'Confirm new password',
            send: 'Send',
            back_to_login: 'Back to login',
            error_invalid_token: 'Invalid or expired token',
            error_wrong_password: 'Password is too short (8 characters minimum)',
            success: 'Your password has been changed, you can close this page',
        },
        Users: {
            title: 'Users',
            error_unable: 'Unable to load the users, please retry later',
            new_item: 'New user',
            item: 'User',
            error_create: 'Unable to create a new user',
            name: 'Name',
            login: 'Login',
            email: 'Email',
            phone: 'Phone',
            id: 'Id',
            validated_account: 'Validated account',
            locked_account: 'Locked account',
            vod_email_notifications_enabled: 'New VOD email notifications',
            contracts: 'Contracts',
            list_application_free: 'List applications free',
            password: 'Password',
            new_password: 'New password',
            new_password_hint: 'Leave empty to keep the current password.',
            link_user: 'Link a user to the contract',
            user_to_link: 'User',
            search_user_placeholder: 'Search by name, login or email',
            no_user_found: 'No user to link',
            unlink_user: 'Unlink the user from the contract',
            unlink_user_confirm: 'The user will lose access to this contract and its applications. The account is kept.',
            error_password_too_short: 'Password is too short.'
        },
        Contracts: {
            title: 'Contracts',
            clusters: 'Clusters',
            error_unable: 'Unable to load the contracts, please retry later',
            new_item: 'New contract',
            item: 'Contract',
            error_create: 'Unable to create a new contract',
            id: 'Id',
            name: 'Name',
            client_name: 'Client name',
            client_contact_name: 'Client contact name',
            client_contact_email: 'Client contact email',
            client_contact_phone: 'Client contact phone',
            invoice_address_0: 'Address (invocing)',
            invoice_address_1: 'Address (invocing) (more)',
            invoice_city: 'City (invocing)',
            invoice_company: 'Company (invocing)',
            invoice_email: 'Email (invocing)',
            invoice_phone: 'Phone (invocing)',
            invoice_vat_nb: 'VAT Rate (invocing)',
            invoice_zipcode: 'Zipcode (invocing)',
            application_config_directory: 'Application configurations directory',
            application_counter: 'Application counter',
            user_counter: 'User counter',
            vod_auto_publish: 'Auto publish VODs'
        },
        Applications: {
            search_device: 'Search a device: name, id, user, OS',
            no_device_found: 'No device found',
            id: 'Id',
            contract_id: 'Contract Id',
            title: 'Applications',
            error_unable: 'Unable to load the applications, please retry later',
            new_item: 'New application',
            item: 'Application',
            error_create: 'Unable to create a new application',
            edit_rights: 'Edit rights',
            error_rights_unable: 'Unable to load the application rights',
            error_update_rights: 'Unable to update the application rights',
            subscription_start_date: 'Subscription start date',
            subscription_end_date: 'Subscription end date',
            config_directory: 'Configuration directory',
            application_type_id: 'Application type Id',
            application_right_template_id: 'Application right template Id',
            conflict: 'Erreur de conflit',
            switch_role: 'Switch role',
            description: 'Description',
            list_user: 'List users',
            max_device_counter: 'Number of application connections',
            list_devices: 'List applicationdevices',
            date_order_error: 'The subscription start date must precede the end date.',
            config_files: 'Configuration files',
            use_device_counter: 'Use device counter',
            application_type_name: 'Application type name'
        },
        ApplicationTypes: {
            id: 'Id',
            name: 'Name',
            web_url: 'Web URL',
            apple_app_store_url: 'Apple App Store URL',
            google_play_store_url: 'Google Play Store URL',
            title: 'Application Types',
            error_unable: 'Unable to load the application types, please retry later',
            new_item: 'New application type',
            item: 'Application type',
            error_create: 'Unable to create the application type',
            error_update: 'Unable to update the application type',
            error_delete: 'Unable to delete the application type',
            edit_right_templates: 'Right templates',
            error_right_templates_unable: 'Unable to load the right templates for this application type',
            new_template: 'New template',
            template_name: 'Template name',
            template_description: 'Description',
            is_default: 'Default template',
            error_create_template: 'Unable to create the right template',
            error_update_template: 'Unable to update the right template',
            error_delete_template: 'Unable to delete the right template',
            right_key: 'Right',
            default_value: 'Enabled by default',
            downloads_visible: 'Visible on the downloads page',
            display_name: 'Display name (downloads)',
            description_fr: 'French description (downloads)',
            description_en: 'English description (downloads)',
            version: 'Published version',
            binaries: 'Binaries',
            downloads: 'Downloads',
            downloads_title: 'Downloadable binaries',
            downloads_hint: 'One binary per platform, published on ncars.isontheair.com/downloads when the type is visible on the downloads page.',
            downloads_visible_short: 'Published',
            platform: 'Platform',
            file: 'File',
            size: 'Size',
            updated_at: 'Updated',
            no_binary: 'No binary',
            choose_file: 'Choose a file…',
            upload: 'Upload',
            delete_binary: 'Delete the binary',
            confirm_delete_binary: "Delete this platform's binary?",
            error_upload: 'Unable to upload the binary',
            error_upload_too_large: 'File too large for the server (413)',
            error_downloads_disabled: 'The downloads storage is not configured on this server',
            error_delete_binary: 'Unable to delete the binary',
        },
        Clusters: {
            cluster_private_http_api_url: "Cluster's private (internal) management API URL",
            cluster_public_http_api_url: "Cluster's public (external) management API URL",
            cluster_public_access_url: "Cluster's public access URL",
            cluster_name: 'Name',
            error_create: 'Unable to create a new cluster',
            error_unable: 'Unable to load the clusters, please retry later',
            id: 'Id',
            item: 'Cluster',
            new_item: 'New cluster',
            title: 'Clusters',
            cluster_api_key: 'Cluster API Key',
            observability: 'Observability',
            status: 'Status',
            online: 'Online',
            offline: 'Offline',
            unknown: 'Unknown',
            last_seen: 'Last seen',
            gateways: 'Gateways',
            sources_free: 'Free sources',
            destinations_free: 'Free destinations',
            sessions: 'Sessions',
            ingress: 'Ingress',
            egress: 'Egress',
            memory: 'Memory',
            throughput: 'Total throughput',
            chart_period: 'Chart time range',
            system_load: 'System load',
            gateway_availability: 'Gateway availability',
            sources: 'sources',
            destinations: 'destinations',
            no_history: 'History will appear after the first samples are collected.',
            stale_snapshot: 'Latest cluster sample is stale:',
            live_logs: 'Live logs',
            logs_redacted: 'Sensitive data redacted',
            no_logs: 'Waiting for new logs…'
        },
        Devices: {
            title: 'Devices',
            search: 'Search: device name or id, user login or name',
            application: 'Application',
            contract: 'Contract',
            user: 'User',
            all_contracts: 'All contracts',
            all_applications: 'All applications',
            no_devices: 'No device',
        },
        Sessions: {
            cluster_id: "Cluster's id",
            cluster_name: "Cluster's name",
            error_create: 'Unable to create a new session',
            error_unable: 'Unable to load the sessions, please retry later',
            id: 'Id',
            item: 'Session',
            new_item: 'New session',
            title: 'Sessions',
            search: 'Search',
            created_at: 'Creation date',
            status: 'Status',
            contract_id: "Contract's id",
            decryption_key: 'Decryption key',
            encryption_key: 'Encryption key',
            sdp: 'SDP file',
            updated_at: 'Updated at',
            tags: 'Tags',
            contract_name: 'Contract',
            source: 'Source',
            consumer_count: 'Consumers',
            source_application: 'Source application',
            unknown_source: 'Unknown source',
            unknown_device: 'Unknown device',
            unknown_application: 'Unknown application',
            graph_title: 'Session links',
            show_ended_consumers: 'Show ended consumers',
            all_contracts: 'All contracts',
            all_clusters: 'All clusters',
            all_source_applications: 'All source applications',
            all_consumers: 'With or without consumers',
            with_consumers: 'With consumers',
            without_consumers: 'Without consumers',
            finished_at: 'End',
            started_at: 'Start',
            ended: 'Ended',
            port: 'Port',
            end_released: 'released',
            end_gone: 'lost',
            end_session_finished: 'session finished',
            hls_video: 'Video HLS',
            hls_audio: 'Audio HLS',
            hls_metadata: 'Metadata HLS',
        },
        Mosaics: {
            title: 'Mosaics',
            new_mosaic: 'New mosaic',
            item: 'Mosaic',
            description: 'Description',
            tags: 'Tags',
            output_url: 'Output URL',
            output_video_port: 'Output video port',
            created_at: 'Created at',
            updated_at: 'Updated at',
            id: 'Id',
            sdp: 'SDP file',
            status: 'Status',
            video_output_port: 'Video output port',
            video_output_SSRC: 'Video output SSRC',
            created: 'Created',
            session_ids: 'Session Ids',
        },
        SwitchSources: {
            title: 'Switch sources',
            item: 'Switch source',
            error_create: "Can't create new switch source",
            error_unable: "Unable to load switch sources, please retry later",
            new_item: 'New switch source',
            external_switch_source_id: 'External switch source id',
            switch_owner_contract_id: 'Switch contract owner',
            switch_source_display_order: "Switch display order",
            switch_source_id: "Id",
            switch_source_is_connected: "is connected",
            switch_source_name: "Name",
            switch_source_picture_url: "Picture url",
            nomade_gateway_config_dir: "Nomade gateway config directory",
            switch_source_nomade_gateway_config_dir: "Nomade gateway config directory",
            switch_source_type: "Switch source type"
        },
        SwitchDestinations: {
            title: 'Switch destinations',
            item: 'Switch destination',
            error_create: "Can't create new switch destination",
            error_unable: "Unable to load switch destinations, please retry later",
            new_item: 'New switch destination',
            switch_destination_destination_application_id: 'Switch destination application id',
            switch_owner_contract_id: 'Switch contract owner',
            switch_destination_display_order: "Switch display order",
            switch_destination_id: "Id",
            switch_destination_is_connected: "is connected",
            switch_destination_name: "Name",
            switch_destination_destination_switch_source_id: "Source",
            switch_destination_destination_type: "Type"
        },
        Register: {
            application_id: "Application Id",
            contract_id: "Contract Id",
            error_unable: "Registration failed",
            title: "Register",
            user_email: "Email",
            confirm_password: 'Confirm new password',
            success: "Registration completed, please check your emails to activate your account.",
            login_already_taken: "Login already taken, please use another one.",
            application_type_name: 'Application type'
        },
        HLS: {
            audio_sessions_ids: "Audio sessions ids",
            created: "Created",
            created_at: "Created at",
            description: "Description",
            directory_path: "Directory Path",
            id: "Id",
            item: "Hls",
            new_hls: "New HLS",
            video_session_id: "Video sessions ids",
            metadata_sessions_ids: "MetaData sessions ids",
            status: "Status",
            title: "HLS",
            updated_at: "Updated at",
            video_decoder: "Video decoder",
            video_encoder: "Video encoder",
            video_encoder_scales: "Video encoder scales",
            playback: "Playback",
            expert_mode: "Expert mode",
            expert_width: "Width",
            expert_height: "Height",
            expert_fps: "FPS",
            expert_bitrate_kbps: "Bitrate (kbps)",
            expert_positive_fields_error: "Expert mode fields must be positive numbers."
        },
        VOD: {
            folder_ids: "Personal folders",
            car_id: 'Car ID',
            car: 'Car',
            id: "Id",
            contract: "Contract",
            contract_id: "Contract",
            all_contracts: "All contracts",
            all_statuses: "All statuses",
            created: "Created",
            created_at: "Created at",
            duration_seconds: "Duration",
            item: "Vod",
            name: "Name",
            new_vod: "New VOD",
            published: "Published",
            has_bus_can: "BUS CAN data",
            status: "Status",
            thumbnail: "Thumbnail",
            thumbnail_mime_type: "Thumbnail mime type",
            title: "VOD",
            type: "Type",
            playback: "Playback",
            event_id: "Event Id",
            close: "Mark as fully uploaded",
            rename: "Rename",
            put_event: "Set event",
            no_event: "No event",
            loading_events: "Loading events…",
            delete: "Delete",
            latitude: "Latitude",
            longitude: "Longitude",
            event: "Event",
            first_chunk_live_start_datetime_utc: "First chunk live start date time UTC",
            origin: "Origin",
            origin_device: "Device",
            origin_application: "Application",
            origin_user: "User",
            filter_device: "Filter on this device",
            clear_filter: "Clear filter",
            merged_into_vod_id: "Merged into VOD",
            merge_parts: "Merged parts",
            parts: "parts",
            show_parts: "Show parts",
            part_start: "Start",
            gap: "Gap",
            merge: "Merge…",
            merge_title: "Merge VODs",
            merge_help: "Only finished VODs from the same device that follow each other less than 1 h apart can be merged. The original VODs are kept and the merge can be undone.",
            merge_master: "Main VOD",
            merge_total: "Total duration",
            merge_no_candidates: "No VOD can be appended after this one.",
            merge_save: "Save",
            merge_separate_all: "Separate all",
            merge_reason_UNKNOWN_DEVICE: "The device that recorded this VOD is unknown.",
            merge_reason_NOT_UPLOADED: "This VOD is not finished (upload in progress or missing).",
            merge_reason_NO_CLUSTER: "This VOD is not attached to any cluster.",
            merge_reason_MERGED_INTO_OTHER: "This VOD is already a part of another VOD."
        },
        Cars: {"title": "Cars", "number": "Number", "description": "Description", "image": "Image", "new_car": "New car", "remove_image": "Remove image", "delete_help": "Delete this car? Its VODs will be kept without a car association.", "invalid_image": "Choose a JPEG, PNG, WebP or GIF image up to 2 MiB.", "duplicate_number": "This number already exists in this contract."},
        Events: {
            contract_id: 'Contract id',
            created_at: 'Creation date',
            created: 'Created',
            description: 'Description',
            geojson: 'GeoJSON',
            id: 'Id',
            item: 'Event',
            name: 'Name',
            new_event: 'New Event',
            title: 'Events',
            download_geojson: 'Download GeoJSON',
            event_map: 'Event map with route and centroid',
            centroid: 'Centroid (latitude, longitude)',
            vod_ids: 'VOD IDs',
            vod_count: 'VOD count',
            start_datetime_utc: "Date and time of beginning (UTC)"
        }
    },

    components: {
        Menu: {
            title: 'ISONTHEAIR',
            connect: 'Connect',
            users: 'Users',
            contracts: 'Contracts',
            clusters: 'Clusters',
            application_types: 'Application types',
            devices: 'Devices',
            sessions: 'Sessions',
            mosaics: 'Mosaics',
            hls: 'HLS',
            vod: 'VOD'
        },
        UserInfos: {
            disconnect: 'Log off',
        },
        LanguageSelector: {
            lang: 'Language',
        },
        MultiSelect: {
            tagPlaceholder: 'Press enter to create a tag',
            placeholder: 'Select option',
            selectLabel: 'Press enter to select',
            deselectLabel: 'Press enter to remove',
            selectedLabel: 'Selected',
        },
    },

    options: {
        ApplicationOss: {
            ANDROID: 'Android',
            IOS: 'IOS',
            LINUX: 'Linux',
            MACOS: 'Mac OS',
            WINDOWS: 'Windows',
        },
        ApplicationSwicthRoles: {
            SWITCH_DESTINATION: 'Destination',
            SWITCH_SOURCE: 'Source',
            SWITCH_NO_ROLE: 'No role',
        },
        UserTypes: {
            USER_ADMIN: 'Administrator',
            USER_CUSTOMER: 'User',
            USER_RESELLER: 'Reseller',
            USER_DIRECTOR: 'Director',
        },
        SwitchSourceTypes: {
            SWITCH_SOURCE_TYPE_APPLICATION: 'Application',
            SWITCH_SOURCE_TYPE_GATEWAY: 'Gateway'
        }
    },
};

export default en;
